{
  "version": 1,
  "asset_id": "93d33362-c9a8-4939-9bed-8f69a44592cc",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/93d33362-c9a8-4939-9bed-8f69a44592cc/egg-scorching.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/93d33362-c9a8-4939-9bed-8f69a44592cc/egg-scorching.webp",
  "original_filename": "egg-scorching.webp",
  "size": 6176,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:20Z"
}
